module.exports = __webpack_public_path__ + "img/download.8f271677.svg";